import React from 'react';
import { Link } from 'react-router-dom';

import { Page } from '@occc-app/design-system';
import { Button, AddIcon } from '@occc/ui-design-system';

import { UsersTableContainer } from './UsersTableContainer';
import { messages } from './messages';

import { routeCreator } from '../utils';

export const UserListPage: React.FC = () => {
  const actions = (
    <Button
      color='secondary'
      variant='contained'
      component={Link}
      to={routeCreator.create()}
      startIcon={<AddIcon />}
      role='button'
    >
      create new user
    </Button>
  );

  return (
    <Page
      browserTabTitle={messages.title}
      actions={actions}
      pageHeaderProps={{ title: messages.title }}
    >
      <UsersTableContainer />
    </Page>
  );
};
